import { z } from 'zod'

export const SupportSlackRootZod = z.object({
  channel: z.string(),
  ts: z.string(),
  settledReaction: z.boolean(),
  lineKeys: z.string().array(),
})
export type SupportSlackRoot = z.infer<typeof SupportSlackRootZod>
